import { AppConfig } from './config.service';

export class HelpManualService {
  public static topics = {
    badge: 'Erfassungsmaske.htm',
    orderChange: 'AuftragAuftragwechsel.htm',
    orderEdit: 'Nachtraege.htm',
    operation: 'Operation-Notiz.htm',
    costCenter: 'Zeiteintraege-editieren.htm',
    note: 'Notiz.htm',
    dayInfo: 'Tages-Uebersicht.htm',
    timeEdit: 'Tages-Uebersicht2.htm',
    reports: 'Auswertung.htm',
    absencePlaner: 'Absenzplaner.htm',
    absences: 'Absenzen2.htm',
    presenceList: 'personal.htm',
    personalReports: 'Personal-Auswertungen.htm',
    personalTimeEntries: 'Zeiteintraege.htm',
    personalBookings: 'Buchungen.htm',
    personalExpenses: 'Personal-Spesen.htm',
    personalMessage: 'Nachricht.htm',
    personalData: 'Personaldaten.htm',
    personalTimeline: 'Zeitachse.htm',
    personalOptionen: 'Optionen.htm',
    personalWarnings: 'Warnungen.htm',
    settings: 'VersionService.htm',
    material: 'Material2.htm',
    spesen: 'Spesen2.htm',
    quantity: 'Menge2.htm',
    noteList: 'Notiz2.htm',
    adminPersons: 'personen.htm',
    adminTimeModel: 'zeitmodelle.htm',
    adminHolidayModel: 'ferienmodelle.htm',
    workflow: 'workflow.htm',
  };

  public static getUrl(topic: string): string {
    let apiUrl = AppConfig.settings.backend.url;
    apiUrl = apiUrl.replace('/api', '');
    return apiUrl + 'manual/index.html?' + topic;
  }
}
